import { render, staticRenderFns } from "./LessonFormDialog.vue?vue&type=template&id=322cc73e&scoped=true"
import script from "./LessonFormDialog.vue?vue&type=script&lang=js"
export * from "./LessonFormDialog.vue?vue&type=script&lang=js"
import style0 from "./LessonFormDialog.vue?vue&type=style&index=0&id=322cc73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322cc73e",
  null
  
)

export default component.exports